import { createSelector } from 'reselect';
const currentStepIndexSelector = (state) => state.progressBar.currentStep;
const stepsSelector = (state) => state.progressBar.steps;
export const currentStepLabelSelector = createSelector([currentStepIndexSelector, stepsSelector], (currentStepIndex, steps) => { var _a; return (_a = steps[currentStepIndex]) === null || _a === void 0 ? void 0 : _a.label; });
